import { textIncludes } from '@/utils/utils'
import { useMemo, useState } from 'react'

export default function useRepositoriesFilter(repositories: any[] = []) {
  const [filterType, setFilterType] = useState('all')
  const [filterValue, setFilterValue] = useState('')

  const data = useMemo(() => {
    return repositories
      .filter((item) => textIncludes(item.name, filterValue))
      .filter((item) => {
        switch (filterType) {
          case 'public':
            return item.personal
          case 'private':
            return !item.personal
          default:
            return true
        }
      })
  }, [repositories, filterType, filterValue])

  return {
    data,
    filterProps: {
      filterType,
      setFilterType,
      filterValue,
      setFilterValue
    }
  }
}
